
import { useTranslation } from "react-i18next";

const DanfeItemsTable = ({items}) => {

const { t } = useTranslation();

  return (
  <table className="danfe-items-table">
    <thead>
      <tr>
        <th className="c-codigo">{t("danfe.productCode").toUpperCase()}</th>
        <th className="c-descricao">{t("danfe.description").toUpperCase()}</th>
        <th className="c-ncm">{t("danfe.ncm").toUpperCase()}</th>
        <th className="c-cst">{t("danfe.cst").toUpperCase()}</th>
        <th className="c-cfop">{t("danfe.cfop").toUpperCase()}</th>
        <th className="c-un">{t("danfe.un").toUpperCase()}</th>
        <th className="c-quant">{t("danfe.qty").toUpperCase()}</th>
        <th className="c-vunit">{t("danfe.unitValue").toUpperCase()}</th>
        <th className="c-vtotal">{t("danfe.totalValue")}</th>
        <th className="c-bcicms">{t("danfe.bicms").toUpperCase()}</th>
        <th className="c-vicms">{t("danfe.vicms")}</th>
        <th className="c-vipi">{t("danfe.vipi").toUpperCase()}</th>
        <th className="c-aicms">{t("danfe.ticms").toUpperCase()}</th>
        <th className="c-aipi">{t("danfe.tipi").toUpperCase()}</th>
      </tr>
    </thead>
    <tbody>
      {items.map((item, index) => (
        <tr key={`${item.codigo}-${index}`}>
          <td>{item.codigo}</td>
          <td>{item.descricao}</td>
          <td>{item.ncm}</td>
          <td>{item.cst}</td>
          <td>{item.cfop}</td>
          <td>{item.un}</td>
          <td>{item.qtde}</td>
          <td>{item.precoUnit}</td>
          <td>{item.precoTotal}</td>
          <td>{item.bcIcms}</td>
          <td>{item.vlrIcms}</td>
          <td>{item.vlrIpi}</td>
          <td>{item.aliqIcms}</td>
          <td>{item.aliqIpi}</td>
        </tr>
      ))}
    </tbody>
  </table>
  )
}

export default DanfeItemsTable;